module.exports = "https://r.zoocdn.com/_next/static/images/City_icon-cf77a5af9c573fbf6024154dfdcedec9.png";